import React, { useState } from "react";
import { Modal, Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { connect } from "react-redux";
import { removeSubjectDependencies } from "Assessments/modules/AssessmentModule";
import SubjectDependenciesInfo from "./SubjectDependenciesInfo";
import classes from "./RemoveSubjectModal.scss";

const RemoveSubjectModal = ({
  parentId,
  parentType,
  portalType,
  updateInputField,
  onClose,
  subjectDependencies,
  headerTitle,
  removeButtonLabel,
  subtitle,
  onRemove,
  modalWidth = "480px",
  fieldList,
  removeSubjectDependencies,
}) => {
  const { t } = useI18n();

  const [isChecked, setIsChecked] = useState(false);

  const handleRemove = () => {
    removeSubjectDependencies({
      subjectDependencies,
      parentId,
      parentType,
      portalType,
      fieldList,
      updateInputField,
      onRemove,
      shouldUseLocalUpdateFunction: true,
    });
  };

  return (
    <Modal height="max-content" width={modalWidth} onClose={onClose}>
      <Modal.Header title={headerTitle} />

      <Modal.Body isScrollable={false}>
        <div className={classes.bodyContainer}>
          <SubjectDependenciesInfo
            title={subtitle}
            isCheckboxChecked={isChecked}
            onClickCheckbox={() => setIsChecked(!isChecked)}
            subjectDependencies={subjectDependencies}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.modalFooter}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="outlined"
            onClick={onClose}
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion="2.0"
            variant="primary"
            onClick={handleRemove}
            disabled={!isChecked}
          >
            {removeButtonLabel}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreators = {
  removeSubjectDependencies,
};

export default connect(null, mapActionCreators)(RemoveSubjectModal);
